<template>
  <v-card>
    <v-toolbar color="primary">
      <v-toolbar-title class="subheading white--text">
        Tabela Fipe
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="py-5 px-4">
      <v-layout column>
        <v-layout>
          <v-flex class="themeGrey--text" pb-3
            >Selecione a tabela Fipe correta do veículo</v-flex
          >
        </v-layout>
        <v-layout>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> DESCRIÇÃO </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-flex class="body-2"> VALOR </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row column>
          <v-layout row align-center wrap>
            <v-flex md12>
              <v-radio-group
                class="check-endosso"
                :hide-details="true"
                required
                v-model="selected"
              >
                <v-layout row v-for="item in listaVeiculo" :key="item.id">
                  <v-radio  :value="item" />

                  <v-flex md7 class="dados-restituicao">
                    {{ item.modelo }}
                  </v-flex>

                  <v-flex md4 align-center> R$ {{ item.valor }}</v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="fechar">VOLTAR </v-btn>
      <v-btn class="primary" flat @click="salvar" :disabled='!selected'> Salvar </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "TabelaFipeModal",
  data: () => {
    return {
      selected: null,
      nrAnoFabricacao: null,
      nrChassi: null,
      nrPlaca: null,
    };
  },
  props: { 
    chassi: String, 
    placa: String,
    listaVeiculo: Array, 
    infoVeiculo: Object,
  },

  watch: {
    "chassi": function () {
      this.$emit("buscarFipe");
    }
  },
  methods: {
    
    salvar() {
      this.$emit("salvar", this.selected, {
        anoFab: this.infoVeiculo.nuAnoModelo || this.infoVeiculo.nrAnoFabricacao,
        chassi: this.infoVeiculo.dsChassiTratado || this.infoVeiculo.nrChassi,
        placa: this.infoVeiculo.nrPlaca,
      });
    },
    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style>
.check-endosso .v-input__control {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/TabelaFipeModal.vue